export default __webpack_public_path__ + "static/media/January2010.50b49712.png";